
import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../../../../websitecomponents/redux/EndPoint/endpoint";
import { toast } from "react-toastify";

const ResellerWithdrawRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const [actionLoading, setActionLoading] = useState(false);

  const [selected, setSelected] = useState(null);
  const [showApprove, setShowApprove] = useState(false);
  const [showReject, setShowReject] = useState(false);

  const [approveAmount, setApproveAmount] = useState("");
  const [holdAmount, setHoldAmount] = useState("");
  const [holdReason, setHoldReason] = useState("");
  const [remark, setRemark] = useState("");

  useEffect(() => {
    fetchRequests();
  }, []);

 
  const fetchRequests = async () => {
    try {
      setLoading(true);
      const res = await axios.get(endPoint.ResellerWithdrawRequests);
      setRequests(res.data.data || []);
    } catch (err) {
      toast.error("Failed to fetch requests");
    } finally {
      setLoading(false);
    }
  };


  const openApprove = (item) => {
    setSelected(item);
    setApproveAmount(item.requestedAmount);
    setHoldAmount(0);
    setHoldReason("");
    setRemark("");
    setShowApprove(true);
  };

  
  const openReject = (item) => {
    setSelected(item);
    setRemark("");
    setShowReject(true);
  };

  const handleApprove = async () => {
    try {
      setActionLoading(true);

      await axios.put(`${endPoint.approveWithdrawRequestRe}/${selected._id}`, {
        status: "approved",
        approvedAmount: Number(approveAmount),
        holdAmount: Number(holdAmount || 0),
        holdReason,
        remark,
      });

      toast.success("Approved successfully");
      setShowApprove(false);
      fetchRequests();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Approve failed");
    } finally {
      setActionLoading(false);
    }
  };

  const handleReject = async () => {
    try {
      setActionLoading(true);

      await axios.put(`${endPoint.approveWithdrawRequest}/${selected._id}`, {
        status: "rejected",
        remark,
      });

      toast.success("Rejected successfully");
      setShowReject(false);
      fetchRequests();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Reject failed");
    } finally {
      setActionLoading(false);
    }
  };

  const statusColor = (status) => {
    if (status === "approved") return "bg-green-100 text-green-700";
    if (status === "rejected") return "bg-red-100 text-red-700";
    return "bg-yellow-100 text-yellow-700";
  };

  if (loading) return <div className="p-6 text-center">Loading...</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* HEADER */}
      <div className="text-2xl font-bold mb-6">Reseller Withdraw Requests</div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow overflow-auto">
        <table className="min-w-full text-sm text-center">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Reseller</th>
              <th className="p-3 text-left">ResellerId</th>
              <th>Amount</th>
              <th>Approved</th>
              <th>Hold</th>
              <th>Hold Reason</th>
              <th>Status</th>
              <th>Date</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {requests.length === 0 ? (
              <tr>
                <td colSpan="9" className="p-4 text-center">
                  No requests found
                </td>
              </tr>
            ) : (
              requests.map((item) => (
                <tr key={item._id} className="border-t hover:bg-gray-50">
                  <td className="p-3">{item.resellerName}</td>
                  <td className="p-3">{item.resellerId}</td>

                  <td className="text-green-600">₹{item.requestedAmount}</td>

                  <td>₹{item.approvedAmount || 0}</td>

                  <td className="text-red-600">₹{item.holdAmount || 0}</td>

                  <td>{item.holdReason || "-"}</td>

                  <td>
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${statusColor(
                        item.status,
                      )}`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>{new Date(item.createdAt).toLocaleDateString()}</td>

                  <td className="text-center">
                    {item.status === "pending" && (
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => openApprove(item)}
                          className="bg-green-500 text-white px-3 py-1 rounded"
                        >
                          Approve
                        </button>

                        <button
                          onClick={() => openReject(item)}
                          className="bg-red-500 text-white px-3 py-1 rounded"
                        >
                          Reject
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* APPROVE MODAL */}
      {showApprove && (
        <Modal title="Approve Withdraw">
          <Input
            label="Approve Amount"
            value={approveAmount}
            onChange={setApproveAmount}
          />
          <Input
            label="Hold Amount"
            value={holdAmount}
            onChange={setHoldAmount}
          />
          <Input
            label="Hold Reason"
            value={holdReason}
            onChange={setHoldReason}
          />
          <Input label="Remark" value={remark} onChange={setRemark} />

          <div className="flex gap-2 mt-4">
            <Button
              text="Confirm"
              onClick={handleApprove}
              loading={actionLoading}
            />
            <Button text="Cancel" onClick={() => setShowApprove(false)} />
          </div>
        </Modal>
      )}

      {/* REJECT MODAL */}
      {showReject && (
        <Modal title="Reject Withdraw">
          <Input label="Remark" value={remark} onChange={setRemark} />

          <div className="flex gap-2 mt-4">
            <Button
              text="Reject"
              onClick={handleReject}
              loading={actionLoading}
            />
            <Button text="Cancel" onClick={() => setShowReject(false)} />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ResellerWithdrawRequests;



const Modal = ({ title, children }) => (
  <div className="fixed inset-0 bg-gray-900 bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
      <h2 className="text-lg font-semibold mb-4">{title}</h2>
      {children}
    </div>
  </div>
);

const Input = ({ label, value, onChange }) => (
  <div className="mb-3">
    <p className="text-sm mb-1">{label}</p>
    <input
      className="w-full border p-2 rounded"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

const Button = ({ text, onClick, loading }) => (
  <button
    onClick={onClick}
    disabled={loading}
    className="bg-blue-600 text-white px-4 py-2 rounded w-full disabled:opacity-50"
  >
    {loading ? "Loading..." : text}
  </button>
);